import moment from 'moment';
import { differenceInCalendarDays, parseISO } from 'date-fns';
import { EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';
import { isStatuspage } from '@atlassian/cssxp-utils-product';

const isValidDate = (d: any) => d instanceof Date && !isNaN(d as any);

export const isStatusPageTrial = (props: EntitlementDetails) => {
  return isStatuspage(props?.productId) && props?.edition?.toLowerCase().includes('trial');
};

export const isTrialEntitlement = (props: EntitlementDetails, isStatusPage: boolean) => {
  return (
    isStatusPageTrial(props) ||
    (!isStatusPage &&
    props?.subscriptionTimestamps?.firstTrialStartTimestamp &&
    props?.subscriptionTimestamps?.lastTrialEndTimestamp
      ? moment.utc(props?.subscriptionTimestamps?.lastTrialEndTimestamp).isSameOrAfter(moment.utc())
      : false)
  );
};

export const getTotalDaysinTrialForStatusPage = (props: EntitlementDetails) => {
  const { subscriptionTimestamps } = props || {};
  let trialStartDate = null,
    trialEndDate = null;
  if (subscriptionTimestamps?.firstStartTimestamp) {
    trialStartDate = new Date(subscriptionTimestamps.firstStartTimestamp);
  }
  if (subscriptionTimestamps?.lastEndTimestamp) {
    trialEndDate = new Date(subscriptionTimestamps.lastEndTimestamp);
  }
  if (props?.latestPeriodStartDate) {
    trialStartDate = new Date(props.latestPeriodStartDate);
  }
  if (props?.latestPeriodEndDate) {
    trialEndDate = new Date(props.latestPeriodEndDate);
  }
  if (trialStartDate && isValidDate(trialStartDate) && trialEndDate && isValidDate(trialEndDate)) {
    return differenceInCalendarDays(trialEndDate, trialStartDate);
  }
  return null;
};

/**
 * This logic applies only to TRIAL Ent of JIRA & Confluence .
 */
export const getTotalDaysInTrial = (
  subscriptions: EntitlementDetails['subscription'],
  currentOfferingId: string,
  upgradeTrialOfferingId: string | null
) => {
  if (!subscriptions?.length) return null;
  let totalDaysInTrial = 0;

  const matchingSubcriptions = subscriptions[0]?.subscriptionPeriod?.filter((subscription) => {
    if (subscription && upgradeTrialOfferingId) {
      return subscription.trial?.offeringId === upgradeTrialOfferingId;
    } else if (subscription) {
      return subscription.offeringKey === currentOfferingId;
    }
  });

  matchingSubcriptions?.forEach((subscription) => {
    if (subscription && subscription.trial && subscription.trial.endTimestamp && subscription.trial.startTimestamp) {
      const differenceInDay = differenceInCalendarDays(
        parseISO(subscription.trial.endTimestamp),
        parseISO(subscription.trial.startTimestamp)
      );

      if (differenceInDay > totalDaysInTrial) {
        totalDaysInTrial = differenceInDay;
      }
    }
  });
  return totalDaysInTrial ? totalDaysInTrial : null;
};
